<template>
  <div>
    <base-dialog customClass="dialog-custom" ref="modifyPasswordDialog" @determine="modifyPasswordDialogDetermine()"
                 @cancel="modifyPasswordDialogClose()" title="修改密码" :pagination="false">
      <div class="dialog-password-title">
        <div>1.必须包含大小写字母，数字和特殊字符</div>
        <div>2.不能包含3位以上连续数字或字母（如ABC、321、000）</div>
        <div>3.密码长度必须8-16位字符（包含8位,16位）</div>
      </div>
      <el-form class="zwx-form" style="padding: 0 !important;" key="modifyForm" ref="modifyForm"
               :model="modifyForm" :rules="modifyFormRules" label-position="right">
        <div class="edit-form" style="max-width: 392px; padding: 10px 0 5px 20px !important;">
          <el-form-item v-if="showOldPassword" label-width="82px" label="旧的密码：" prop="oldPassword">
            <el-input class="zwx-input zwx-input-password" style="width: 290px !important;"
                      v-model="modifyForm.oldPassword" placeholder="请输入"
                      :type="modifyForm.plaintext1 ? 'password' : null">
              <i slot="suffix"
                 :class="!modifyForm.plaintext1?'el-input__icon  outline chis-icon-outline-eye':'el-input__icon outline chis-icon-outline-eye-invisible'"
                 @click="modifyForm.plaintext1=!modifyForm.plaintext1"/>
            </el-input>
          </el-form-item>
          <el-form-item label-width="82px" label="新的密码：" prop="newPassword">
            <el-input class="zwx-input zwx-input-password" style="width: 290px !important;"
                      v-model="modifyForm.newPassword" placeholder="请输入"
                      :type="modifyForm.plaintext2 ? 'password' : null" @input="clearBlank($data['modifyForm'], 'newPassword')">
              <i slot="suffix"
                 :class="!modifyForm.plaintext2?'el-input__icon  outline chis-icon-outline-eye':'el-input__icon outline chis-icon-outline-eye-invisible'"
                 @click="modifyForm.plaintext2=!modifyForm.plaintext2"/>
            </el-input>
          </el-form-item>
          <el-form-item label-width="82px" label="确认密码：" prop="confirmPassword">
            <el-input class="zwx-input zwx-input-password" style="width: 290px !important;"
                      v-model="modifyForm.confirmPassword" placeholder="请输入"
                      :type="modifyForm.plaintext3 ? 'password' : null"  @input="clearBlank($data['modifyForm'], 'confirmPassword')">
              <i slot="suffix"
                 :class="!modifyForm.plaintext3?'el-input__icon  outline chis-icon-outline-eye':'el-input__icon outline chis-icon-outline-eye-invisible'"
                 @click="modifyForm.plaintext3=!modifyForm.plaintext3"/>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
    </base-dialog>
  </div>
</template>

<script>
export default {
  name: "PasswordModify",
  props: {
    specifyUserUuid: {
      type: String,
      default: ''
    },
    showOldPassword:{
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      api: this.$store.state.api,
      baseUrl: this.$store.state.baseUrl,
      modifyForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        plaintext1: true,
        plaintext2: true,
        plaintext3: true,
      },
      modifyFormRules: {
        oldPassword: [{required: this.showOldPassword, message: '请输入旧的密码', trigger: ['change', 'blur']}],
        newPassword: [{required: true, validator: this.$validate.validPassword, trigger: ['change', 'blur']}],
        confirmPassword: [{required: true, validator: this.confirmPasswordRules, trigger: ['change', 'blur']}],
      },

    }
  },
  created() {
  },
  mounted() {
  },
  computed: {},
  methods: {
    clearBlank(data, field){
      if (field === undefined || field === null || field === '') return ''
      data[field] = data[field].replace(/\s/g,"")
    },
    modifyPassword() {
      this.$refs.modifyPasswordDialog.show(true)
    },
    modifyPasswordDialogClose() {
      this.$refs.modifyPasswordDialog.show(false)
      this.modifyForm.oldPassword = ''
      this.modifyForm.newPassword = ''
      this.modifyForm.confirmPassword = ''
    },
    modifyPasswordDialogDetermine() {
      this.$refs['modifyForm'].validate(valid => {
        if (valid) {
          this.$emit('loading', true)
          let data = {
            specifyUserUuid: this.specifyUserUuid,
            oldPassword: this.$zwxSm.sm2Encrypt123(this.modifyForm.oldPassword),
            newPassword: this.$zwxSm.sm2Encrypt123(this.modifyForm.newPassword),
            showOldPassword: this.showOldPassword,
          }
          this.$system.post(this.api + '/systematic/modifyCurrentOrSpecifyUserPassword-0', data, false, true, data => {
            if (data.type === '00') {
              this.$system.notify('成功', data.mess, 'success')
              this.modifyPasswordDialogClose();
              this.$emit('loading', false)
            } else if (data.type === '99') {
              this.$router.push({name: 'ErrorPage', params: {mess: data.mess}})
            } else {
              this.$system.notify('错误', data.mess, 'error')
              this.$emit('loading', false)
            }
          }, () => {
            this.$system.notify('错误', '网络连接失败', 'error')
            this.$emit('loading', false)
          })
        }
      })
    },
    confirmPasswordRules(rule, value, callback) {
      if(this.$zwxBase.verifyIsNotBlank(this.modifyForm.newPassword)){
        if(this.$zwxBase.verifyIsBlank(value)){return callback(new Error('请输入确认密码'))}
        if (this.modifyForm.newPassword !== this.modifyForm.confirmPassword) return callback(new Error('两次输入的密码不一致'))
        return callback()
      }else{
        return callback()
      }
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.dialog-custom .el-dialog {
  min-width: 0 !important;
  width: 420px !important;
}

.dialog-custom .dialog-password-title {
  font-size: 13px !important;
  color: #475669 !important;
  font-weight: 400 !important;
  margin-left: 20px !important;
  margin-top: 10px !important;
}

.dialog-custom .el-icon-warning {
  color: #4494f9 !important;
}
</style>